/**
 * VendorTermPeriodService
 * Service for managing vendor term periods
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor term period CRUD operations
 */
export class VendorTermPeriodService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorTermPeriodService.DEFAULT_SERVICE_PATH,
            basePath: VendorTermPeriodService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorTermPeriodService.DEFAULT_SERVICE_PATH = 'vendors';
VendorTermPeriodService.BASE_PATH = 'api/vendor-term-periods';
//# sourceMappingURL=VendorTermPeriodService.js.map